import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRsvpDeadlineQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRsvpDeadlineQuery = {
  __typename?: 'Query';
  getRsvpSettingsByEventId?: {
    __typename?: 'RsvpSettings';
    id: string;
    isOpen: boolean;
    deadlineEnabled: boolean;
    showDeadline: boolean;
    deadlineDate?: any | null;
    deadlineNote?: string | null;
    deadlineTimezone?: string | null;
    eventHasDate?: boolean | null;
  } | null;
};

export const GetRsvpDeadlineDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRsvpDeadline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRsvpSettingsByEventId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showDeadline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineTimezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventHasDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRsvpDeadlineQuery__
 *
 * To run a query within a React component, call `useGetRsvpDeadlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRsvpDeadlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRsvpDeadlineQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRsvpDeadlineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRsvpDeadlineQuery, GetRsvpDeadlineQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRsvpDeadlineQuery, GetRsvpDeadlineQueryVariables>(GetRsvpDeadlineDocument, baseOptions);
}
export function useGetRsvpDeadlineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRsvpDeadlineQuery, GetRsvpDeadlineQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRsvpDeadlineQuery, GetRsvpDeadlineQueryVariables>(GetRsvpDeadlineDocument, baseOptions);
}
export type GetRsvpDeadlineQueryHookResult = ReturnType<typeof useGetRsvpDeadlineQuery>;
export type GetRsvpDeadlineLazyQueryHookResult = ReturnType<typeof useGetRsvpDeadlineLazyQuery>;
export type GetRsvpDeadlineQueryResult = Apollo.QueryResult<GetRsvpDeadlineQuery, GetRsvpDeadlineQueryVariables>;
